import { FC } from "react";
import { Link } from "react-router-dom";

import { AreaListingProps } from "./type";



const AreasListing: FC<AreaListingProps> = ({ title, territories }): JSX.Element => {
  const findPath = () => {
    if(title === "Area Manager") {
      return '/regions'
    } else if(title === "Regional Manager") {
      return '/districts'
    } else if(title === "Reps") {
      return '/territories'
    } else if(title === "Practices") {
      return '/practice_stats'
    } else if (title === "Doctors") {
      return "/doctor_stats"
    } else if (title === "Areas") {
      return "/regions"
    } else if (title === "Regions") {
      return "/districts"
    }else if (title === "Territories") {
      return "/territories"
    }
  };

  return (
    <div className="card h-100">
      <div className="card-header">
        <h4 className="m-0 text-center">{title}</h4>
      </div>

      <div className="card-body p-0">
        <table className="table table-responsive table-hover" >
          <thead className="table-light">
            <tr className="text-center">
              <th>Name</th>
              <th>Cases</th>
            </tr>
          </thead>

          <tbody>
            {territories && territories.data && territories.data.length > 0 &&
              territories.data.map((item, key) =>
                <tr className="text-center" key={key}>
                  <td>
                    <Link
                      to={{
                        pathname: `${findPath()}/${item.id.toString()}`,
                        search: (() => {
                          const newParams = new URLSearchParams()
                          newParams.set("role", item.role);
                          return newParams.toString();
                        })(),
                      }}
                      className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
                    >
                      {item.name}
                    </Link>
                  </td>
                  <td>{item?.cases}</td>
                </tr>
              )
            }
          </tbody>

          <tfoot>
            <tr className="text-center">
              <td className="fw-bold">Total</td>
              <td className="fw-bold">{territories?.case_total}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default AreasListing;
